import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSyncAborted = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m10.0001 18.3333c-2.21076.002-4.33153-.8754-5.89477-2.4386-1.56323-1.5632-2.44057-3.684-2.43858-5.89474v-.16667c.06816-3.33982 2.12317-6.31654 5.22197-7.56412s6.64308-.52514 9.00638 1.83579c2.3854 2.3834 3.0993 5.96944 1.8086 9.08464-1.2907 3.1153-4.3316 5.1457-7.7036 5.1437zm0-7.1583 2.1583 2.1583 1.175-1.175-2.1583-2.15834 2.1583-2.15834-1.175-1.175-2.1583 2.15834-2.15835-2.15834-1.175 1.175 2.15834 2.15834-2.15834 2.15834 1.175 1.175 2.15835-2.1575z",
		fill: "#ca4139"
	})
});
export { SvgSyncAborted as ReactComponent };
